module.exports = __webpack_public_path__ + "img/flag1.7f73762f.png";